import * as React from 'react';
import { SectionPanel } from 'ui';
import { TranslationsComponent, SecondaryTextMode } from 'app/components/translation';
import { FilterOption } from 'app/components/options-handler/types';

import { renderSlot } from '../screen-renderer/render-slot';
import { CodetableItemFormComponentProps } from '../codetable-item-form';
import { shouldRenderTranslations } from '../codetable-item-form-render-helpers';
import { ReadOnlyType, SlotProps } from '../types';
import { MAX_LENGTH_DESCRIPTION, MAX_LENGTH_LONG_DESCRIPTION } from './constants';
import { TranslationsProps } from './types';
import { updateLanguages } from './update-languages';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

const getLanguageOptions = (options: { [key: string]: FilterOption }) =>
  (options?.languages?.codes ?? []) as CodeComplexValue<number>[];

export class Translations extends React.Component<Partial<CodetableItemFormComponentProps> & TranslationsProps & SlotProps> {

  private onDescriptionChange = (languageId: number, description: string) => {

    const { onDescriptionChange, codeItem } = this.props;

    const trimmedDescription = description !== undefined ? description.trim() : undefined;

    onDescriptionChange(languageId, updateLanguages(languageId, codeItem.description, trimmedDescription));
  };

  private onLongDescriptionChange = (languageId: number, longDescription: string) => {

    const { onLongDescriptionChange, codeItem } = this.props;

    const trimmedLongDescription = longDescription !== undefined ? longDescription.trim() : undefined;

    onLongDescriptionChange(languageId, updateLanguages(languageId, codeItem.longDescription, trimmedLongDescription));
  };

  private copyDescriptionToAllTranslations = () => {
    const { mainLanguage, codeItem, options, translation,
      metadata: { features }, copyDescriptionToAllTranslations } = this.props;

    const languageOptions = getLanguageOptions(options);

    copyDescriptionToAllTranslations({
      codeItem,
      languageOptions,
      features,
      mainLanguage,
      successText: translation.copied_description_to_all
    });
  };

  private copyLongDescriptionToAllTranslations = () => {
    const { mainLanguage, codeItem, options, translation,
      metadata: { features }, copyLongDescriptionToAllTranslations } = this.props;

    const languageOptions = getLanguageOptions(options);

    copyLongDescriptionToAllTranslations({
      codeItem,
      languageOptions,
      features,
      mainLanguage,
      successText: translation.copied_long_description_to_all
    });
  };

  public render() {
    const {
      codeItem, metadata, mainLanguage, options,
      hasTranslationsToggled, switchTranslationsToggle,
      translation, validation, sectionSlots, sectionRef, readOnlyConfig
    } = this.props;

    if (!shouldRenderTranslations(metadata)) {
      return null;
    }

    const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.translations];

    return <div ref={sectionRef}>
      {renderSlot(sectionSlots, 'top', this.props)}
      <SectionPanel
        className="admin-paper-top-panel"
        componentId="descriptions_and_translations"
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={codeItem?.description}
        secondaryText={codeItem?.longDescription}
        primaryTextValueKey="description"
        secondaryTextValueKey="longDescription"
        primaryTextMaxLength={MAX_LENGTH_DESCRIPTION}
        secondaryTextMaxLength={MAX_LENGTH_LONG_DESCRIPTION}
        languageOptions={getLanguageOptions(options)}
        mainLanguage={mainLanguage?.value}
        mainLanguageDescription={mainLanguage?.description}
        secondaryTextMode={metadata.features.longDescription
          ? SecondaryTextMode.normal
          : SecondaryTextMode.disabled}
        readOnly={readOnly}
        onPrimaryTextChange={this.onDescriptionChange}
        onSecondaryTextChange={this.onLongDescriptionChange}
        copyPrimaryTextToAllTranslations={this.copyDescriptionToAllTranslations}
        copySecondaryTextToAllTranslations={this.copyLongDescriptionToAllTranslations}
        hasTranslationsToggled={hasTranslationsToggled}
        switchTranslationsToggle={switchTranslationsToggle}
        validation={validation?.language}
        primaryTextLabel={translation?.description}
        secondaryTextLabel={translation?.long_description}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        copySecondaryTextToAllLabel={translation?.copy_long_description_to_all}
        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations}
      />
      {renderSlot(sectionSlots, 'bottom', this.props)}
    </div>;
  }
}
